module.exports = __webpack_public_path__ + "stickermule-wordmark-c753294da3312afaa03b32fb8759a707.webp";